/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SettingsDto } from '../../models/settings-dto';

export interface GetSettings$Params {
  type: string;
}

export function getSettings(http: HttpClient, rootUrl: string, params: GetSettings$Params, context?: HttpContext): Observable<StrictHttpResponse<SettingsDto>> {
  const rb = new RequestBuilder(rootUrl, getSettings.PATH, 'get');
  if (params) {
    rb.path('type', params.type, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SettingsDto>;
    })
  );
}

getSettings.PATH = '/settings/{type}';
